import { DEFAULT_LANDING_PAGE_ACCENT_COLOR } from '@consts';
import XIcon from '@icons/XIcon';
import { setupForDark } from '@theme';
import classNames from 'classnames';

export default function LandingPageKeywordChip({
  text,
  accentColor = DEFAULT_LANDING_PAGE_ACCENT_COLOR,
  onRemove,
  removeAriaLabel
}: {
  text: string;
  accentColor?: string;
  onRemove?: () => void;
  removeAriaLabel?: string;
}) {
  return (
    <div
      className={classNames(
        'flex items-center gap-xs rounded-xxxl border border-solid bg-landing-surface-card',
        setupForDark('text-white'),
        // RESPONSIVE STYLES
        'px-md py-xs text-[16px] @[640px]:px-lg @[640px]:py-sm @[640px]:text-[20px] font-medium'
      )}
      style={{ borderColor: accentColor }}
    >
      <span className='break-words'>{text}</span>
      {onRemove && (
        <button
          type='button'
          onClick={onRemove}
          aria-label={removeAriaLabel}
          className='flex items-center justify-center shrink-0 cursor-pointer opacity-70 hover:opacity-100'
        >
          <XIcon size={16} className={setupForDark('text-white')} />
        </button>
      )}
    </div>
  );
}
